/* eslint-disable lodash/prefer-lodash-method */
import { ThunkDispatch, EmptyObject, AnyAction } from '@reduxjs/toolkit';
import * as FileSaver from 'file-saver';
import moment from 'moment';
import { Dispatch } from 'react';
import { PersistPartial } from 'redux-persist/es/persistReducer';
import { NotificationsExportResponseType, NotificationsExportVehicleConsultExcelResponseType } from '../../../../services/Notifications/types';
import { notificationsListSlice } from '../../../../stores';
import { delay } from '../../../../utils/Helpers';

export const exportVehicleConsultToCSV = async (
  apiData: NotificationsExportVehicleConsultExcelResponseType,
  dispatch: ThunkDispatch<EmptyObject & PersistPartial, undefined, AnyAction> &
    Dispatch<AnyAction>,
  worker: (apiData: NotificationsExportVehicleConsultExcelResponseType) => Promise<string>,
): Promise<void> => {
  dispatch(notificationsListSlice.actions.setNotificationsExportPercentage(20));

  const handledApiData = await worker(apiData);
  dispatch(notificationsListSlice.actions.setNotificationsExportPercentage(70));

  const fileType = 'data:text/csv;charset=utf-8;';
  const fileExtension = '.csv';
  dispatch(
    notificationsListSlice.actions.setNotificationsExportPercentage(100),
  );
  await delay(100);

  const blob = new Blob([handledApiData], {
    type: fileType,
  });

  FileSaver.saveAs(
    blob,
    `consultas-agente-de-transito-${moment().format('yyyy-MM-DD_hh-mm')}` + fileExtension,
  );

  return;
};

export const handleApiDataVehicleConsultToCSV = (
  apiData: NotificationsExportVehicleConsultExcelResponseType,
) => {
  const formatDateTime = (dateTime: string) => {
    return (
      dateTime[8] +
      dateTime[9] +
      '/' +
      dateTime[5] +
      dateTime[6] +
      '/' +
      dateTime[0] +
      dateTime[1] +
      dateTime[2] +
      dateTime[3] +
      ' ' +
      dateTime.slice(11)
    );
  };

  const formatSituation = (situation: string) => {
    if (situation == 'I') {
      return 'Irregular';
    }

    if (situation == 'R') {
      return 'Regular';
    }

    if (situation == 'A') {
      return 'AIT Paga';
    }

    return '';
  }

  let handledApiData = `"Agente de trânsito";"Login";"Data/Hora";"Placa";"Situação";\r\n`;

  apiData.map((item) => {
    const dateTime = formatDateTime(item.dateTime);

    handledApiData = handledApiData +
      `"${item.name}";"${item.login}";"${dateTime}";"${item.plate}";"${formatSituation(item.situation)}";\r\n`;
  });

  return handledApiData;
};

export const exportNotificationsToCSV = async (
  apiData: NotificationsExportResponseType,
  dispatch: ThunkDispatch<EmptyObject & PersistPartial, undefined, AnyAction> &
    Dispatch<AnyAction>,
  worker: (apiData: NotificationsExportResponseType) => Promise<string>,
): Promise<void> => {
  dispatch(notificationsListSlice.actions.setNotificationsExportPercentage(20));

  const handledApiData = await worker(apiData);
  dispatch(notificationsListSlice.actions.setNotificationsExportPercentage(70));

  const fileType = 'data:text/csv;charset=utf-8;';
  const fileExtension = '.csv';
  dispatch(
    notificationsListSlice.actions.setNotificationsExportPercentage(100),
  );
  await delay(100);

  const blob = new Blob([handledApiData], {
    type: fileType,
  });

  FileSaver.saveAs(
    blob,
    `notificacoes-${moment().format('yyyy-MM-DD_hh-mm')}` + fileExtension,
  );

  return;
};

export const handleApiDataNotificationsToCSV = (
  apiData: NotificationsExportResponseType,
) => {
  const formatDateTime = (dateTime: string) => {
    return (
      dateTime[8] +
      dateTime[9] +
      '/' +
      dateTime[5] +
      dateTime[6] +
      '/' +
      dateTime[0] +
      dateTime[1] +
      dateTime[2] +
      dateTime[3] +
      ' ' +
      dateTime.slice(11)
    );
  };
  const formatMoney = (money: string) => {
    // eslint-disable-next-line lodash/prefer-lodash-method
    return `R$${money.toString().replace('.', ',')}`;
  };

  let handledApiData = `"Identificador";"Veículo";"Preço";"Usuário";"Hora de notificação";"Tipo da notificação";"Trecho";"Observação";\r\n`;

  apiData.map((item) => {
    const registerDateTime = formatDateTime(item.registerDateTime);
    // .format('DD/MM/YYYY HH:mm:ss')

    handledApiData =
      handledApiData +
      `"${item.id}";"${item.type && item.brand
        ? `${item.plate} / ${item.brand} (${item.type})`
        : item.plate
      }";"${item.price ? formatMoney(item.price) : '-'}";"${item.userLogin
      }";"${registerDateTime}";"${item.situation === 'C'
        ? 'Cancelada'
        : item.situation === 'I'
          ? 'Irregular'
          : item.situation === 'P'
            ? 'Paga'
            : item.situation === 'A'
              ? 'AIT Paga'
              : 'Regular'
      }";"${item.routeName}";"${item.observation}";\r\n`;
  });

  return handledApiData;
};